// utils/routerUtils.js
import Vue from 'vue'
export const gotoFundDetail = (options) => {
  console.log(options)
  return new Promise((resolve) => {
    const fundCode = options.query.fundCode
    Vue.$mc.postJson('/fundDetail/queryTransAftCode', { fundCode: fundCode }, {headers: { showLoading: false }})
      .then((data) => {
        resolve(data)
      })
      .catch(() => {
        resolve(fundCode)
      })
  })

}



// WEBPACK FOOTER //
// ./src/utils/routerUtils.js